module.exports = __webpack_public_path__ + "images/soccer1-3a0605ca82493243544531baa6c72636.jpg";